import { render, staticRenderFns } from "./err-result.vue?vue&type=template&id=4bf781cc&scoped=true&"
import script from "./err-result.vue?vue&type=script&lang=js&"
export * from "./err-result.vue?vue&type=script&lang=js&"
import style0 from "./err-result.vue?vue&type=style&index=0&id=4bf781cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf781cc",
  null
  
)

export default component.exports